import { motion, useScroll, useTransform, useSpring } from 'framer-motion';
import { ArrowLeftRight, Coins, Package, Repeat, Zap, ShieldCheck, TrendingUp, Search, Sparkles, HeartHandshake } from 'lucide-react';

const icons = [
  { Icon: ArrowLeftRight, color: "text-blue-500", top: '12%', left: '8%', size: 60, speed: -220, rotateSpeed: 140 },
  { Icon: Coins, color: "text-yellow-500", top: '22%', left: '84%', size: 75, speed: -320, rotateSpeed: -180 },
  { Icon: Package, color: "text-green-500", top: '72%', left: '10%', size: 70, speed: -180, rotateSpeed: 100 },
  { Icon: Repeat, color: "text-purple-500", top: '82%', left: '82%', size: 65, speed: -360, rotateSpeed: -220 },
  { Icon: Zap, color: "text-orange-500", top: '42%', left: '4%', size: 45, speed: -260, rotateSpeed: 160 },
  { Icon: ShieldCheck, color: "text-indigo-500", top: '8%', left: '52%', size: 55, speed: -140, rotateSpeed: -100 },
  { Icon: TrendingUp, color: "text-red-500", top: '62%', left: '90%', size: 50, speed: -240, rotateSpeed: 200 },
  { Icon: Search, color: "text-cyan-500", top: '52%', left: '46%', size: 85, speed: -190, rotateSpeed: -120 },
  { Icon: Sparkles, color: "text-pink-500", top: '32%', left: '18%', size: 45, speed: -280, rotateSpeed: 240 },
  { Icon: HeartHandshake, color: "text-rose-500", top: '78%', left: '42%', size: 55, speed: -230, rotateSpeed: -150 },
];

function FloatingIconItem({ item, scrollY }) {
  const y = useTransform(scrollY, [0, 2500], [0, item.speed]);
  const rotate = useTransform(scrollY, [0, 2500], [0, item.rotateSpeed]);
  const scale = useTransform(scrollY, [0, 1000, 2500], [1, 1.15, 0.85]);
  
  const springY = useSpring(y, { stiffness: 60, damping: 25 });
  const springRotate = useSpring(rotate, { stiffness: 60, damping: 25 });

  return (
    <motion.div
      className={`absolute ${item.color} hidden md:block`}
      style={{
        top: item.top,
        left: item.left,
        y: springY,
        rotate: springRotate,
        scale: scale,
      }}
    >
      <item.Icon size={item.size} strokeWidth={1.2} />
    </motion.div>
  );
}

export default function FloatingBackground() {
  const { scrollY } = useScroll();

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden -z-10 opacity-[0.25] dark:opacity-[0.3]">
      {icons.map((item, index) => (
        <FloatingIconItem key={index} item={item} scrollY={scrollY} />
      ))}
    </div>
  );
}
